import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axiosInstance";

export const getCurrency = createAsyncThunk(
  "service/getCurrency",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-currency");
      //   console.log("The res is :", res.data);
      return res.data; // ✅ just return the whole data object
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const getTimeZone = createAsyncThunk(
  "service/getTimeZone",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/get-timezone", payload);
      // console.log("The res of getting time zone from thunk is :", res.data);
      return res.data; // ✅ just return the whole data object
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const getGallery = createAsyncThunk(
  "service/getGallery",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get(
        "/list-service-provider-gallery-images",
      );
      // console.log("The res of image is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const addOrUpdateService = createAsyncThunk(
  "service/addOrUpdateService",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        "/add-or-update-service-provider-detail",
        payload,
      );

      if (!res.data.success) {
        return rejectWithValue(res.data.message);
      }
      // console.log("The res is :", res.data);
      return res.data; // ✅ just return the whole data object
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const otherServiceImages = createAsyncThunk(
  "register/otherServiceImages",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post("/upload-multiple-images", payload);
      // console.log("The data response for the  profile upload is :", res.data);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  },
);

export const getServiceDetails = createAsyncThunk(
  "register/getServiceDetails",
  async (_, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.get("/get-service-provider-detail");
      // console.log("The res of service provider detail is :", res.data);
      return res.data;
    } catch (err) {
      console.log("err ", err);
    }
  },
);
